<div class="modal-header modalHeaderBlack">
    <h6 class="modal-title">{{ "master.NextOfKin" | translate }}</h6>
    <span
      aria-label="Close"
      class="close"
      (click)="onClick()"
      data-automation-attribute="span-close-dialog"
    >
      <mat-icon matTooltip="{{ 'AddInternalNotes.close' | translate }}"
        >clear</mat-icon
      >
    </span>
  </div>
  
  <div class="divepisodeconversion">
    <div class="example-container">
      <table
        mat-table
        [dataSource]="dataSourceNextOfKin"
        class="height150 divFullWidth"
      >
        <ng-container matColumnDef="nokName">
          <th mat-header-cell *matHeaderCellDef class="headerDescription">
            {{ "common.nokName" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="headerDescription">
            {{ element ? element.name : "" }}
          </td>
        </ng-container>
  
        <ng-container matColumnDef="relationship">
          <th mat-header-cell *matHeaderCellDef class="headerDescription">
            {{ "master.relationship" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="headerDescription">
            {{element ? element.relation : "" }}
          </td>
        </ng-container>
  
        <ng-container matColumnDef="idType">
          <th mat-header-cell *matHeaderCellDef class="headerDescription">
            {{ "AppointmentPage.idType" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="headerDescription">
            {{ element ? element.identificationType : "" }}
          </td>
        </ng-container>
  
        <ng-container matColumnDef="idNo">
          <th mat-header-cell *matHeaderCellDef class="headerDescription">
            {{ "common.idNo" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="headerDescription">
            {{ element ? element.identificationNo : "" }}
          </td>
        </ng-container>
  
        <ng-container matColumnDef="mobileNo">
          <th mat-header-cell *matHeaderCellDef class="headerDescription">
            {{ "AppointmentListPage.mobileNo" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="headerDescription">
            {{ element ? element.mobileNo : "" }}
          </td>
        </ng-container>
  
        <ng-container matColumnDef="isGuarantor">
          <th mat-header-cell *matHeaderCellDef class="headerDescription">
            {{ "EncounterPage.isguarantor" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="headerDescription"
            style="text-align: center"
          >
            <mat-icon
              class="check-icon"
              *ngIf="element.isGurantor; else notGuarantorIcon"
              >check</mat-icon
            >
            <ng-template #notGuarantorIcon>
              <mat-icon class="close-icon">close</mat-icon>
            </ng-template>
          </td>
        </ng-container>
  
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumnsNextOfKinDetails; sticky: true"
          class="tableHeaderGreen"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsNextOfKinDetails"
          class="tableRow"
        ></tr>
      </table>
    </div>
  </div>
  